var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-dropdown-item',_vm._g(_vm._b({},'b-dropdown-item',_vm.$attrs,false),_vm.mountEventListeners),[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }